import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import NinetyDaysPanel from '../Panels/NinetyDaysPanel/NinetyDaysPanel';
import ShipWithBoxPanel from '../Panels/ShipWithBoxPanel/ShipWithBoxPanel';

const Subscriptions = ({
  isCustomizeOpen,
  goWithBoxSubscriptions,
  goWithBoxPriceTotal,
  ninetyDaysSubscriptions,
  ninetyDaysPriceTotal,
  sysdata,
  editCampaign,
  isRefillOnly,
}) => {
  const hasNinetyDaysPanelItems = ninetyDaysSubscriptions.length > 0;

  return (
    <div
      id="subscriptions"
      data-testid="subscriptions-container"
      data-e2e="subscriptions-container"
    >
      {!isRefillOnly && (
        <ShipWithBoxPanel
          subscriptions={goWithBoxSubscriptions}
          displayShopNowBtn={isCustomizeOpen || editCampaign?.userAccess}
          sysdata={sysdata}
          subTotal={goWithBoxPriceTotal}
          editCampaign={editCampaign}
        />
      )}
      {isCustomizeOpen ? (
        // Only display the "Shipping Every 3 Months"
        // if user has a subscription
        hasNinetyDaysPanelItems && (
          <NinetyDaysPanel
            subscriptions={ninetyDaysSubscriptions}
            sysdata={sysdata}
            displaySeparator={false}
            subTotal={ninetyDaysPriceTotal}
            editCampaign={editCampaign}
          />
        )
      ) : (
        // Display both sections when Customize is CLOSED
        <NinetyDaysPanel
          subscriptions={ninetyDaysSubscriptions}
          sysdata={sysdata}
          displaySeparator={false}
          subTotal={ninetyDaysPriceTotal}
          editCampaign={editCampaign}
        />
      )}
    </div>
  );
};

Subscriptions.propTypes = {
  isCustomizeOpen: bool.isRequired,
  goWithBoxSubscriptions: arrayOf(object).isRequired,
  ninetyDaysSubscriptions: arrayOf(object).isRequired,
  sysdata: shape({
    boxData: shape({
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }),
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
  }).isRequired,
  goWithBoxPriceTotal: number.isRequired,
  ninetyDaysPriceTotal: number.isRequired,
  editCampaign: shape({}).isRequired,
  isRefillOnly: bool.isRequired,
};

const mapStateToProps = (state) => ({
  editCampaign: state.campaigns.edit,
});

export default connect(mapStateToProps)(Subscriptions);
